const { createSelector } = require('reselect');

const selectProductsWithFilters = (state) =>
  state['marketplace.marketCustomerCatalogue'].productWithFilters;

const productWithFilters = () =>
  createSelector([selectProductsWithFilters], (show) => show.data);

const productWithFiltersError = () =>
  createSelector([selectProductsWithFilters], (show) => show.error);

const productWithFiltersLoading = () =>
  createSelector([selectProductsWithFilters], (show) => show.loading);

//

const selectProductCategory = (state) =>
  state['marketplace.marketCustomerCatalogue'].productCategory;

const productCategory = () =>
  createSelector([selectProductCategory], (show) => show.data);

const productCategoryError = () =>
  createSelector([selectProductCategory], (show) => show.error);

const productCategoryLoading = () =>
  createSelector([selectProductCategory], (show) => show.loading);

//

const selectProductsWithoutFilters = (state) =>
  state['marketplace.marketCustomerCatalogue'].productWithoutFilters;

const productsWithoutFilters = () =>
  createSelector([selectProductsWithoutFilters], (show) => show.data);

const productsWithoutFiltersError = () =>
  createSelector([selectProductsWithoutFilters], (show) => show.error);

const productsWithoutFiltersLoading = () =>
  createSelector([selectProductsWithoutFilters], (show) => show.loading);

const selectProductsWithSearch = (state) =>
  state['marketplace.marketCustomerCatalogue'].productWithSearch;

const productsWithSearch = () =>
  createSelector([selectProductsWithSearch], (show) => show.data);

const productsWithSearchError = () =>
  createSelector([selectProductsWithSearch], (show) => show.error);

const productsWithSearchLoading = () =>
  createSelector([selectProductsWithSearch], (show) => show.loading);

const selectNewProducts = (state) =>
  state['marketplace.marketCustomerCatalogue'].newProducts;

const newProducts = () =>
  createSelector([selectNewProducts], (show) => show.data);

const newProductsError = () =>
  createSelector([selectNewProducts], (show) => show.error);

const newProductsLoading = () =>
  createSelector([selectNewProducts], (show) => show.loading);

const selectFeaturedProducts = (state) =>
  state['marketplace.marketCustomerCatalogue'].featuredProducts;

const featuredProducts = () =>
  createSelector([selectFeaturedProducts], (show) => show.data);

const featuredProductsError = () =>
  createSelector([selectFeaturedProducts], (show) => show.error);

const featuredProductsLoading = () =>
  createSelector([selectFeaturedProducts], (show) => show.loading);

const selectParticularProducts = (state) =>
  state['marketplace.marketCustomerCatalogue'].particularProducts;

const particularProducts = () =>
  createSelector([selectParticularProducts], (show) => show.data);

const particularProductsError = () =>
  createSelector([selectParticularProducts], (show) => show.error);

const particularProductsLoading = () =>
  createSelector([selectParticularProducts], (show) => show.loading);

const selectStoreDetails = (state) =>
  state['marketplace.marketCustomerCatalogue'].storeDetails;

const storeDetails = () =>
  createSelector([selectStoreDetails], (show) => show.data);

const storeDetailsError = () =>
  createSelector([selectStoreDetails], (show) => show.error);

const storeDetailsLoading = () =>
  createSelector([selectStoreDetails], (show) => show.loading);

const selectStoreProductsList = (state) =>
  state['marketplace.marketCustomerCatalogue'].storeProductList;

const storeProductsList = () =>
  createSelector([selectStoreProductsList], (show) => show.data);

const storeProductsListError = () =>
  createSelector([selectStoreProductsList], (show) => show.error);

const storeProductsListLoading = () =>
  createSelector([selectStoreProductsList], (show) => show.loading);

const selectStoreFeaturedProductsList = (state) =>
  state['marketplace.marketCustomerCatalogue'].storeFeaturedProductList;

const storeFeaturedProductsList = () =>
  createSelector([selectStoreFeaturedProductsList], (show) => show.data);

const storeFeaturedProductsListError = () =>
  createSelector([selectStoreFeaturedProductsList], (show) => show.error);

const storeFeaturedProductsListLoading = () =>
  createSelector([selectStoreFeaturedProductsList], (show) => show.loading);

module.exports = {
  productWithFilters,
  productWithFiltersError,
  productWithFiltersLoading,

  productsWithoutFilters,
  productsWithoutFiltersError,
  productsWithoutFiltersLoading,

  productsWithSearch,
  productsWithSearchError,
  productsWithSearchLoading,

  newProducts,
  newProductsError,
  newProductsLoading,

  featuredProducts,
  featuredProductsError,
  featuredProductsLoading,

  particularProducts,
  particularProductsError,
  particularProductsLoading,

  storeDetails,
  storeDetailsError,
  storeDetailsLoading,

  storeProductsList,
  storeProductsListError,
  storeProductsListLoading,

  storeFeaturedProductsList,
  storeFeaturedProductsListError,
  storeFeaturedProductsListLoading,

  productCategory,
  productCategoryError,
  productCategoryLoading,
};
